import ApiService from "@/core/services/api.service";

export default {
  /**
   * Attempt to delete group schedule using GROUP ID.
   *
   * @param context
   * @param payload
   */
  deleteGroupSchedule(context, payload) {
    console.log("Payload is: ", payload);

    ApiService.setHeader();
    return ApiService.delete("group/schedule", {
      params: {
        id: payload.id,
      },
    });
  },
};
